import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91fa336e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { className: "relative w-full h-[300px]" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { className: "absolute top-0 right-2 text-gray-200 animate-bounce text-2xl" }, " ● ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { className: "absolute bottom-1/4 right-1/4 text-gray-200 animate-bounce text-2xl" }, " ● ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { className: "absolute top-1/3 left-10 text-gray-200 animate-bounce text-2xl" }, " ● ", -1))
const _hoisted_5 = { className: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" }
const _hoisted_6 = { className: "rounded-xl overflow-hidden relative" }
const _hoisted_7 = { className: "rounded-md flex items-center justify-center w-full" }
const _hoisted_8 = { className: "blob flex items-center justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_v_icon, {
              name: _ctx.icon ?? 'md-lockperson-twotone',
              class: "text-h-primary-50 p-5",
              scale: 17
            }, null, 8, ["name"])
          ])
        ])
      ])
    ])
  ]))
}